import { cloneDeep } from 'lodash';

import getZDL from '../utils/getZDL';
import { TransferClientError } from '../../../errors';

import { Fetch } from '../../shared/types';
import type { Zap, ZDL } from '../types';

export type Options = {
  accountId: number;
  transferZap: Zap;
};

/**
 * Remove IDs and meta properties that were specific to the source ZDL
 * which will result in errors if copied to the Workflow zap.
 */
const cleanZDL = (zdl: ZDL): ZDL => {
  zdl.id = '_GEN_root';
  zdl.steps = zdl.steps.map((step, index) => {
    step.id = `_GEN_${index}`;
    step.meta = {
      transfer: {
        isCreatedByTransfer: true,
      },
    };
    return step;
  });
  return zdl;
};

export const createWorkflowZapFromTransfer = (
  fetch: Fetch,
  { accountId, transferZap }: Options
): Promise<Zap> => {
  if (transferZap.kind !== 'transfer') {
    throw new TransferClientError(
      `Zap ${transferZap.id} must be a transfer zap`
    );
  }

  return fetch<Zap>('/api/gulliver/storage/v1/zaps', {
    body: {
      title: transferZap.title,
      description: transferZap.description,
      zdl: cleanZDL(cloneDeep(getZDL(transferZap))),
      kind: 'workflow',
    },
    params: {
      account_id: accountId,
    },
  });
};

export default createWorkflowZapFromTransfer;
